import useNewReportPage from "./hooks/useNewReportPage";
import Page from "../../components/Page";

const NewReportPage = () => {
  const page = useNewReportPage();
  return <Page {...page} />;
};

export default NewReportPage;
